import { Grid, TextField } from '@mui/material';
import { Stack } from '@mui/system';

import React, { useState } from 'react';

import ButtonComp from 'common/components/Button/ButtonComp';

import styles from './NotApplicableCitation.module.scss';

const { textBoxColor, textBoxBackGround } = styles;

interface INotApplicable {
	item: any;
	handleChange: any;
	handleClick: any;
	handleCancelClick: any;
	isTextBoxDisabled: boolean;
}

const NotApplicableCitation = (notApplicable: INotApplicable) => {
	const {
		item,
		handleChange,
		handleClick,
		handleCancelClick,
		isTextBoxDisabled,
	} = notApplicable;

	const [value, setValue] = useState<string>(item?.applicabilityComments || '');

	const [commentsAdded, setCommentsAdded] = useState<boolean>(false);
	const [firstComment, setFirstComment] = useState<string>('');

	const handleInputTextChange = (event: any) => {
		event.preventDefault();
		if (!commentsAdded) {
			setCommentsAdded(true);
			setFirstComment(value);
		}
		setValue(event.target?.value.trimStart());
		handleChange(event.target?.value.trimStart());
	};

	const handleSubmit = (event: any) => {
		setFirstComment(value);
		setCommentsAdded(false);
		handleChange(value);
		handleClick(event);
		handleCancelClick(event);
	};

	const cancel = (event: any) => {
		setCommentsAdded(false);
		setValue(firstComment);
		handleChange(firstComment);
		handleCancelClick(event, firstComment);
	};
	return (
		<Stack direction="column">
			<TextField
				required
				disabled={isTextBoxDisabled}
				id="outlined-multiline-static"
				name="outlined-multiline-static"
				label="Explaination of non-applicability designation"
				sx={{
					'&.MuiTextField-root': {
						background: textBoxBackGround,
					},
				}}
				multiline
				InputProps={{
					inputProps: { 'data-testid': 'outlined-multiline-static' },
					classes: {
						notchedOutline: value
							? styles['mui-text-box']
							: styles['mui-text-box-coloured'],
					},
				}}
				InputLabelProps={{
					sx: { color: textBoxColor, '&.Mui-focused': { color: textBoxColor } },
				}}
				rows={4}
				value={value}
				onChange={(e) => handleInputTextChange(e)}
				className={styles['mui-text-box']}
			/>
			<Grid
				container
				className={styles['grid-container']}
				justifyContent="flex-end"
			>
				<Stack direction="row" gap="10px">
					<ButtonComp btnType="secondary" clickHandler={cancel}>
						Cancel
					</ButtonComp>
					<ButtonComp
						btnType="primary"
						disabled={value.length <= 0 || isTextBoxDisabled}
						clickHandler={handleSubmit}
						data-testid="button"
					>
						Save
					</ButtonComp>
				</Stack>
			</Grid>
		</Stack>
	);
};

export default NotApplicableCitation;
